export const LAPTOPS_ID = 'c0265416-b017-4527-9fa6-a0ec665eb8b9';
export const DELL_ID = '13cde339-e1d0-4228-9de1-1ff0715d45c0';
export const APPLE_ID = '375c9db2-051b-49e5-b818-4be151ac326d';
export const MICROSOFT_ID = 'bb57249a-f382-433d-a6bf-1f9731e4b06c';

export const calculateDeviceRequirementAnnual = (
  numEmployees: number,
  churnPercentage: number,
  gsdPercentage: number
) => +(numEmployees * ((churnPercentage + gsdPercentage) / 100)).toFixed(2);
